import formMixin from '../../../mixins/formMixin'

export default {
    name: 'FormSelect',

    mixins: [formMixin]
}
